import YAML from 'yaml';
import type {ThemeDefinition} from '../../core/presentation-registry';
import manifest from './theme.yaml?raw';

export const defaultTheme = YAML.parse(manifest) as ThemeDefinition;
